<div class="title">{{ title }}</div>
<p class="subtitle" *ngIf="subtitle">{{ subtitle }}</p>
<div class="mat-form-field-wrapper">
  <div
    *ngFor="let color of colors.controls; let i = index"
    [attr.data-index]="i"
  >
    <form [formGroup]="color">
      <mat-form-field appearance="outline">
        <mat-label>Kleur {{ i + 1 }}</mat-label>
        <input
          type="text"
          matInput
          formControlName="name"
          (input)="answered($event)"
          required
        />
      </mat-form-field>
    </form>
  </div>
  <!-- <button mat-stroked-button (click)="addColor()">
    <mat-icon color="primary" style="line-height: 0.85em;">add</mat-icon>
    Voeg kleur toe
  </button> -->
</div>
